import Row from '@amzn/meridian/row';
import Select, { SelectOption } from '@amzn/meridian/select';
import Text from '@amzn/meridian/text';
import React, { FC, useState } from 'react';
import { TranslationFunction } from '../../blocks';
import { HelpPopover } from '../../constructed';

interface PoIdFilterProps {
    value: string[];
    onChange: (values: string[]) => void;
    t: TranslationFunction;
}

const PoIdFilter: FC<PoIdFilterProps> = ({ value, onChange, t }) => {
    const [searchQuery, setSearchQuery] = useState('');

    const handleChange = (newValues: string[]) => {
        const parsed = newValues.flatMap((v) => v.split(/\s+/).filter(Boolean));
        onChange([...new Set(parsed)]);
        setSearchQuery('');
    };

    return (
        <Row alignmentVertical={'center'}>
            <HelpPopover position={'bottom'} header={t('poIdSearchHelp-header')}>
                <Text tag={'ul'}>
                    <li>{t('poIdSearchHelp-singleId')}</li>
                    <li>{t('poIdSearchHelp-multipleIds')}</li>
                </Text>
            </HelpPopover>
            <Select
                value={value}
                onChange={handleChange}
                searchQuery={searchQuery}
                onSearch={setSearchQuery}
                label={t('purchaseOrderIds-label')}
                placeholder={t('searchByIds-placeholder')}
                data-testid={'poIdFilter'}
            >
                {searchQuery.trim() && !value.includes(searchQuery.trim()) && (
                    <SelectOption
                        label={
                            /\s+/.test(searchQuery.trim())
                                ? t('addMultipleIds-label')
                                : t('addId-label', { id: searchQuery.trim() })
                        }
                        value={searchQuery}
                        key={`add-${searchQuery}`}
                    />
                )}
                {value.map((poId) => (
                    <SelectOption label={poId} value={poId} key={poId} />
                ))}
            </Select>
        </Row>
    );
};

export default PoIdFilter;
